import React from "react";
import { Formik } from "formik";
import { useSelector, useDispatch } from "react-redux";

import { BillingAmountSchema } from "schemas/billingAmountSchema";
import { selectBillingAmount } from "app/store/billingAmount/slice/billingAmountSlice";
import { useUpdateBillingAmountMutation } from "app/store/billingAmount/api/billingAmountApi";

import ModalWrapper from "components/common/modals/modalWrapper/ModalWrapper";
import BillingAmountInputForm from "components/pages/billingAmount/form/BillingAmountInputForm";
import { Button } from "@mui/material";

import RpmBillingAmountInputForm from "../form/RpmBillingAmountInputForm";
import SubmitButton from "components/Button/SubmitButton";
import { showErrorToast, showSuccessToast } from "utils/toast";

const BillingAmountModal = () => {
  const { selectedBillingAmount } = useSelector((state) => state.billingAmount);
  const [updateBillingAmount, { error }] = useUpdateBillingAmountMutation();

  const dispatch = useDispatch();

  const onClose = () => {
    dispatch(selectBillingAmount(null));
  };

  return (
    <ModalWrapper
      show={!!selectedBillingAmount}
      title={`Billing Amount- ${selectedBillingAmount?.name}`}
      onClose={onClose}
    >
      <Formik
        initialValues={{
          ...selectedBillingAmount,
          billing: selectedBillingAmount?.billing?.map((billing) => ({
            code: billing?.code,
            amount: billing?.amount || 0,
            display: billing?.display,
          })),
          rpmBilling: selectedBillingAmount?.rpmBilling?.map((rpmBilling) => ({
            code: rpmBilling?.code,
            amount: rpmBilling?.amount || 0,
            display: rpmBilling?.display,
          })),
        }}
        initialErrors={{}}
        validateOnChange={true}
        validateOnBlur={true}
        validationSchema={BillingAmountSchema}
        onSubmit={async (values, { setSubmitting, resetForm }) => {
          try {
            setSubmitting(true);

            const billing = values?.billing?.map((item) => ({
              code: item?.code,
              amount: Number(item?.amount || 0),
              display: item?.display,
            }));

            const rpmBilling = values?.rpmBilling?.map((item) => ({
              code: item?.code,
              amount: Number(item?.amount || 0),
              display: item?.display,
            }));

            const payload = { _id: values._id, billing, rpmBilling };

            await updateBillingAmount(payload);

            if (error) {
              showErrorToast(error.message);
            }

            showSuccessToast("Billing Amount updated successfully", false);
            onClose();

            resetForm();
          } catch (err) {
            showErrorToast(err.message);
          } finally {
            setSubmitting(false);
          }
        }}
      >
        {(formikProps) => (
          <>
            <BillingAmountInputForm formikProps={formikProps} />

            {formikProps?.values?.rpmBilling && (
              <RpmBillingAmountInputForm
                title="RPM Billing Code"
                titleStyle={{ marginBottom: "24px" }}
                formikProps={formikProps}
              />
            )}

            <div className="buttons-wrapper">
              <Button
                variant="outlined"
                color="secondary"
                disabled={formikProps?.isSubmitting}
                onClick={() => {
                  formikProps?.resetForm();
                  onClose();
                }}
              >
                Cancel
              </Button>
              <SubmitButton
                handleClick={
                  formikProps?.isSubmitting ? null : formikProps?.handleSubmit
                }
                buttonText={formikProps?.isSubmitting ? "Saving..." : "Save"}
              />
            </div>
          </>
        )}
      </Formik>
    </ModalWrapper>
  );
};

export default BillingAmountModal;
